import React from 'react';
import { AdminVisitReasonsContainer } from '@/components/Organization/VisitReasons/Admin/AdminVisitReasonsContainer';
import { PageTitle } from '@/components/common/PageTitle/PageTitle';
import { RouteContentWrapper } from '../../styles';

export const AdminVisitReasonsRoute = () => {
    return (
        <RouteContentWrapper>
            <PageTitle title="Visit Reasons" />
            <AdminVisitReasonsContainer />
        </RouteContentWrapper>
    );
};
